import { US_STATE_OPTIONS } from '../../../../../../constants';
import { MEDICAL_DIAGNOSIS_OPTIONS as MEDICAL_DIAGNOSIS_VALUES } from '../constants';

import type { MedicalDiagnosisFormValues } from '../types';

export const EMPTY_MEDICAL_DIAGNOSIS_VALUES: MedicalDiagnosisFormValues = {
  diagnosis_name: '',
  provider_name: '',
  city: '',
  state: '',
  year: null,
};

export const MEDICAL_DIAGNOSIS_OPTIONS = MEDICAL_DIAGNOSIS_VALUES;

export const MEDICAL_DIAGNOSIS_FIELD_OPTIONS = MEDICAL_DIAGNOSIS_OPTIONS.map((value) => ({
  label: value,
  value,
}));

export const MEDICAL_DIAGNOSIS_STATE_OPTIONS = US_STATE_OPTIONS;
export const MEDICAL_DIAGNOSIS_PROVIDER_MIN_LENGTH = 8;
export const MEDICAL_DIAGNOSIS_CITY_MIN_LENGTH = 2;
export const MEDICAL_DIAGNOSIS_TEXT_MAX_LENGTH = 255;
export const MEDICAL_DIAGNOSIS_YEAR_MIN = 1900;
export const MEDICAL_DIAGNOSIS_YEAR_MAX = 2100;
